import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedDate, FormattedMessage, FormattedNumber } from 'react-intl';

import { FormatMessage } from '../core';
import { useUsers } from '../../user/UserContext';
import { orderConfirmationSummaryMessages, OrderPointsMessages } from './confirmationMessages';
import { userClient } from "../../user/userClient";

export const SAPConfirmationSummary = ({ orderNumber, orderTotalAmount }) => {
    const { userData } = useUsers();
    const [availableAmount, setAvailableAmount] = useState(0);

    
    
    

    useEffect(() => {
        userClient.getUser().then(data => {
            setAvailableAmount(data.availableAmount);
        })
    });

    return (
        <div className="order-confirmation-summary">
            <h2 className="order-confirmation-summary-heading">
                <FormattedMessage {...orderConfirmationSummaryMessages.heading} />
            </h2>
            <FormatMessage
                intlMessage={orderConfirmationSummaryMessages.description}
                className="order-confirmation-summary-description"
            />
            <FormatMessage
                intlMessage={orderConfirmationSummaryMessages.orderNumberLabel}
                className="order-confirmation-summary-order-num-label"
            />
            <div className="order-confirmation-summary-order-num">{orderNumber}</div>
            <div className="order-confirmation-summary-date">
                <FormattedDate value={new Date()} year="numeric" month="long" day="2-digit" />
            </div>
            <div className="order-summary-totals-line">
                <div className="order-summary-totals-label">
                    <FormattedMessage {...OrderPointsMessages.FlexRewardsDollarsUsed} />
                </div>
                <div className="order-summary-totals-value">
                    <FormattedNumber style="currency" currency={userData.currency || 'USD'} value={orderTotalAmount} />
                </div>
            </div>
            <div className="order-summary-totals-line order-summary-totals-total">
                <div className="order-summary-totals-label">
                    <FormattedMessage {...OrderPointsMessages.FlexRewardsDollarsRemaining} />
                </div>
                <div className="order-summary-totals-value">
                    <FormattedNumber
                        style="currency"
                        currency={userData.currency || 'USD'}
                        value={availableAmount}
                    />
                </div>
            </div>
        </div>
    );
};

SAPConfirmationSummary.propTypes = {
    orderNumber: PropTypes.string.isRequired,
    orderTotalAmount: PropTypes.number.isRequired
};
